const authors = require('./sovietAuthors')

module.exports = Object.keys(authors).reduce((hash, name) => {
  const author = Object.assign({}, authors[name], { name: name })

  author.authorEmails.forEach(email => hash[email] = author)

  return hash
}, {})
